import {
  GET_HEALTH_CHECK_INVOICES_STARTED,
  GET_HEALTH_CHECK_INVOICES_SUCCESS
} from '../../actions/actionTypes'

const defaultState = {
  hotelData: [],
  months: [],
  hotelGroups: {},
  hotelChains: {},
  isLoading: true
}

export default function invites(state = { ...defaultState }, action) {
  switch (action.type) {
    case GET_HEALTH_CHECK_INVOICES_STARTED:
      return {
        ...state,
        isLoading: true
      }

    case GET_HEALTH_CHECK_INVOICES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hotelData: action.payload.hotelData,
        months: action.payload.months,
        hotelGroups: action.payload.hotelGroups,
        hotelChains: action.payload.hotelChains
      }

    case 'SAVE_POSTED_SUBSIDIARY':
      return {
        ...defaultState
      }

    default:
      return state
  }
}
